<template>
  <img :src="logoSrc" :alt="alt" :class="computedClass" />
</template>

<script>
import { clients } from '@/config/clients';
import { useGlobalStore } from '@/stores/global';

export default {
  name: 'LogoBig',
  props: {
    alt: {
      type: String,
      default: 'Logo',
    },
    className: {
      type: String,
      default: 'h-14 mb-6',
    },
  },
  computed: {
    logoSrc() {
      const store = useGlobalStore();
      // Use landingConfig logo_big_url if available and not empty
      if (
        store.landingConfig?.logo_big_url &&
        store.landingConfig.logo_big_url.trim() !== ''
      ) {
        return store.landingConfig.logo_big_url;
      }

      const theme = document.documentElement.getAttribute('data-theme');
      return clients[theme]?.logoBig;
    },
    computedClass() {
      return this.className;
    },
  },
};
</script>
